import { render, staticRenderFns } from "./CustomerContractDetails.vue?vue&type=template&id=0c2053c0&scoped=true"
import script from "./CustomerContractDetails.vue?vue&type=script&lang=js"
export * from "./CustomerContractDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerContractDetails.vue?vue&type=style&index=0&id=0c2053c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2053c0",
  null
  
)

export default component.exports